
export default {
  name: 'StretchFull',
  props: {
    top: {
      type: String,
      default: '-64px',
    },
  },
}
